import { connect } from 'react-redux'
import {
  selectFilteredCcRecipients,
  selectFilteredBccRecipients,
  selectRecipientQuery,
  selectIsSearchingRecipients,
  selectLastFilteredCcRecipientsSize,
  selectLastFilteredBccRecipientsSize,
} from 'selectors/modals'
import { doClearUserSuggestion } from 'actions/tickets'
import {
  selectRecipients,
  selectCurrentSuggestedRecipients,
  doSearchRecipients,
  doAddDraftRecipients,
  doRemoveDraftRecipients,
  doUpdateReplyDraftRecipients,
  doRemoveNoteDraftToRecipient,
  doUpdateNoteDraftToRecipient,
} from 'ducks/drafts'
import { emptyArr } from 'util/arrays'
import { emptyObj } from 'util/objects'
import { runOnNextTick, debounce } from 'util/functions'
import RecipientSearch from './view'

const emptyArray = []

const selectFactory = (initialState, initialOwnProps) => {
  const { type, isForwarding } = initialOwnProps

  return state => {
    const query = selectRecipientQuery(state)
    const recipients = selectRecipients(state)
    let filtered
    let lastFilteredSize
    let recipientSet = recipients[type]

    if (!query) {
      filtered = isForwarding
        ? emptyArr
        : selectCurrentSuggestedRecipients(state)
    } else if (type === 'bcc') {
      filtered = selectFilteredBccRecipients(state)
      lastFilteredSize = selectLastFilteredBccRecipientsSize(state)
    } else if (type === 'to') {
      filtered = selectFilteredCcRecipients(state)
      lastFilteredSize = selectLastFilteredCcRecipientsSize(state)
      recipientSet = emptyArray
    } else {
      filtered = selectFilteredCcRecipients(state)
      lastFilteredSize = selectLastFilteredCcRecipientsSize(state)
    }

    return {
      filtered,
      lastFilteredSize,
      isSearching: selectIsSearchingRecipients(state),
      recipients: recipientSet,
    }
  }
}

const performFactory = (initialState, initialOwnProps) => {
  const {
    forNote,
    ticketId,
    type,
    onSelect,
    afterToAdd,
    skipOnAdd,
    onUpdateCustom,
  } = initialOwnProps

  return dispatch => ({
    doClearUserSuggestion: () => {
      dispatch(doClearUserSuggestion())
    },
    onAdd: (recipient, recipients) => {
      if (skipOnAdd) return false

      if (type === 'to' && onSelect) onSelect()

      if (onUpdateCustom) {
        const newRecipients = [].concat(recipients)
        newRecipients.push(recipient)
        onUpdateCustom(newRecipients)
      } else {
        const action = forNote
          ? doUpdateNoteDraftToRecipient(ticketId, recipient)
          : doAddDraftRecipients(ticketId, { [type]: recipient })
        dispatch(action)
      }

      if (type === 'to' && afterToAdd) runOnNextTick(afterToAdd)

      return true
    },
    onUpdate: recipients => {
      if (type === 'to' && onSelect) onSelect()

      if (onUpdateCustom) {
        onUpdateCustom(recipients)
      } else {
        const firstRecipient =
          recipients && recipients.length > 0 ? recipients[0] : emptyObj
        const action = forNote
          ? doUpdateNoteDraftToRecipient(ticketId, firstRecipient)
          : doUpdateReplyDraftRecipients(ticketId, { [type]: recipients })
        dispatch(action)
      }

      if (type === 'to' && afterToAdd) runOnNextTick(afterToAdd)
    },
    onRemove: (recipient, recipients) => {
      if (onUpdateCustom) {
        const index = recipients.indexOf(recipient)
        const newRecipients = [].concat(recipients)
        newRecipients.splice(index, 1)
        onUpdateCustom(newRecipients)
      } else {
        const action = forNote
          ? doRemoveNoteDraftToRecipient(ticketId, recipient)
          : doRemoveDraftRecipients(ticketId, { [type]: recipient })
        dispatch(action)
      }
    },
    searchRecipients: debounce(query => {
      const withoutIds = emptyArray // placeholder
      dispatch(doSearchRecipients(type, query, withoutIds))
    }, 200),
  })
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
})

export default connect(selectFactory, performFactory, mergeProps)(
  RecipientSearch
)
